export default __webpack_public_path__ + "static/newsletter-background-08529dce48de6332d9075d358927e23e.png";